import { createClient } from '@supabase/supabase-js';

// IMPORTANT: point these at your NEW 2026 Supabase project.
// Set them in .env (see .env.example). There are deliberately NO
// hardcoded fallbacks here -- the 2025 app shipped its live URL and anon
// key in source, which meant anyone with the bundle could read and write
// the league database.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseKey);

if (!isSupabaseConfigured) {
  // eslint-disable-next-line no-console
  console.error(
    'Supabase is not configured. Create a .env file with ' +
    'REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY, then restart.'
  );
}

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseKey)
  : null;
